export default __webpack_public_path__ + "static/media/login-banner.497cd966.svg";